let setSuccessRef: ((msg: string | null) => void) | null = null;

export const registerGlobalSuccessSetter = (
  fn: (msg: string | null) => void
) => {
  setSuccessRef = fn;
};

export const unregisterGlobalSuccessSetter = () => {
  setSuccessRef = null;
};

export const pushGlobalSuccess = (msg: string | null) => {
  if (setSuccessRef) setSuccessRef(msg);
};
